import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import './testimonial.css'; // use your styles here
import { FaStar } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';



const testimonials = [
    {
        id: 1,
        // image: '//c2.staticflickr.com/8/7310/buddyicons/24846422@N06_r.jpg',
        name: 'New Sky Property',
        rating: 5,
        review:
            'Electiaa transformed our outdated website into a modern, mobile-friendly platform that truly reflects our brand. Their attention to detail, creativity, and responsiveness exceeded our expectations. Highly recommended!"',
    },
    {
        id: 2,
        // image: 'https://i.postimg.cc/ydBjdm20/michael-dam-m-EZ3-Po-FGs-k-unsplash-1.jpg',
        name: 'First Sky Infra',
        rating: 4,
        review:
            '"Working with Electiaa was an absolute pleasure. They listened to our needs, delivered on time, and created a stunning website that has improved our online visibility. A professional team with great design sense!"',
    },
    {
        id: 3,
        // image: 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/451270/profile/profile-80.jpg',
        name: 'HiTech Fibre',
        rating: 5,
        review:
            'From concept to launch, Electiaa handled our project with professionalism and care. The design is sleek, fast, and user-friendly. We have received so many compliments from our customers!',
    },
       {
        id: 4,
        // image: 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/451270/profile/profile-80.jpg',
        name: 'Redite',
        rating: 5,
        review:
            'Electiaa team is creative, reliable, and very responsive. They gave our website a fresh look that boosted engagement and helped us stand out in a competitive market.',
    },
     {
        id: 4,
        // image: 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/451270/profile/profile-80.jpg',
        name: 'Triplette',
        rating: 4,
        review:
            'We needed a website that was clean, modern, and easy to navigate. Electiaa delivered exactly that—and more. Their post-launch support is also excellent!',
    },
];

const TestimonialCarousel = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [imageAnimation, setImageAnimation] = useState(false);
    const settings = {
        dots: true,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        beforeChange: (_, next) => {
            setImageAnimation(false); // Remove animation before slide
            setCurrentSlide(next);
        },
        afterChange: () => {
            setImageAnimation(true); // Trigger animation after slide
        },
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
    };
    const getThumb = (offset) => {
        const index = (currentSlide + offset + testimonials.length) % testimonials.length;
        return testimonials[index];
    };

      useEffect(() => {
        AOS.init({
          duration: 1000,
          once: true,
        });
    
        setTimeout(() => {
          AOS.refresh();
        }, 500);
      }, []);

    return (
        <section className="customer-feedback">
            <div className="container text-center">
                {/* <h1 className="section-title-about" style={{ color:"white", marginTop:"10px"}}>Testimonial</h1> */}
                <section className='section-margin'>
            <center>
              <div className='heading-for-all' data-aos='fade-up'>
                <h2>testimonial</h2>
              </div>
            </center>
          </section>
               
                <div className="testimonial-wrapper" data-aos='fade-up' data-aos-delay='1000' >
                    <Slider {...settings}>
                        {testimonials.map((testimonial) => (
                            <div className="feedback-slider-item" key={testimonial.id}>
                                {/* <img
                                    src={testimonial.image}
                                    className={`img-circle center-block ${imageAnimation ? 'animated zoomIn' : ''}`}
                                    alt="Customer"
                                    // style={{ width: 85, height: 85 }}
                                /> */}

                                <p>{testimonial.review}</p>
                                <h3 className="customer-name">{testimonial.name}</h3>

                                <span className="light-bg customer-rating">
                                    {testimonial.rating} <FaStar color='gold' />
                                </span>
                            </div>
                        ))}
                    </Slider>

                    {/* <div className="feedback-slider-thumb hidden-xs d-flex justify-content-between mt-4">
                        <div className="thumb-prev">
                            <img
                                src={getThumb(-1).image}
                                alt="Previous"
                                // width={50}
                                // height={50}
                                className={`img-circle size-image ${imageAnimation ? 'animated zoomIn' : ''}`}
                            />
                            <div className="customer-rating">
                                {getThumb(-1).rating} <i className="fa fa-star" />
                            </div>
                        </div>
                        <div className="thumb-next">
                            <img
                                src={getThumb(1).image}
                                alt="Next"
                                // width={50}
                                // height={50}
                                className={`img-circle size-image ${imageAnimation ? 'animated zoomIn' : ''}`}
                            />
                            <div className="customer-rating">
                                {getThumb(1).rating} <i className="fa fa-star" />
                            </div>
                        </div>
                    </div> */}

                </div>
            </div>
        </section>
    );
};

// Custom Arrow Components
function PrevArrow(props) {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick}>
            <i className="fa fa-long-arrow-left"></i>
        </div>
    );
}

function NextArrow(props) {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick}>
            <i className="fa fa-long-arrow-right"></i>
        </div>
    );
}

export default TestimonialCarousel;
